/*
 * Accordion
 *
 **/
custom.formLabelAnimation = (() => {
  const containerClassName = 'js-form-label-animation';
  //const initClassName = 'js-form-label-animation--initialized';
  const focusClass = 'focused';
  const validClass = 'valid';

  const classToggleHandler = (event = null) => {
    const $input = $(event.currentTarget);
    const $container = $input.closest('.' + containerClassName);

    if (event.type == 'focus') {
      $container.addClass(focusClass);
    } else if (event.type == 'blur') {
      toggleValidClass(null, event.currentTarget);
    }
  };

  function toggleValidClass(index = null, el = null) {
    const $container = $(el).closest('.' + containerClassName);
    $container.removeClass(focusClass);

    return $(el).val() != ''
      ? $container.addClass(validClass)
      : $container.removeClass(validClass);
  }

  function init() {
    const $inputs = $('.' + containerClassName).find(
      'input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="password"], textarea',
    );

    // Form focus animation class toggle
    $.each($inputs, (index, input) => {
      toggleValidClass(index, input);

      // if ($(input).closest('.' + containerClassName).hasClass(initClassName)) return;
      $(input).on('change', toggleValidClass);
      $(input).on('focus blur', classToggleHandler);
    });
  }

  return {
    init,
    toggleValidClass,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-label-animation.js